import { FC } from 'react';
import { Button, Modal } from 'components/core';
import { Styled } from './';
import { MdErrorOutline } from 'react-icons/md';
import { useI18n } from 'contexts/i18n';
import { limitExceededErrorMessage } from '../OrderCheckout';

interface QuantityLimitModalProps {
  onClose: () => void;
  errorMessage?:
    | string
    | {
        name: string;
        max_quantity: number;
        requested_quantity: number;
      }[];
}

const WarningModal: FC<QuantityLimitModalProps> = ({
  onClose,
  errorMessage,
}) => {
  const i18n = useI18n();
  
  const isLimitExceededError = Array.isArray(errorMessage);

  const exceededItemsMessages = isLimitExceededError
    ? limitExceededErrorMessage(
        errorMessage,
        i18n['EXCEEDED_ITEMS_LIMIT_MESSAGE']
      )
    : [];

  return (
    <Modal>
      <Styled.Container>
        <Styled.Header>
          <MdErrorOutline size="28px" style={{ color: '#e57373' }} />
          <span>{i18n['Warning']}</span>
        </Styled.Header>

        <Styled.Body>
          {isLimitExceededError ? (
            <>
              <p>{i18n['EXCEEDED_ITEMS_LIMIT_MESSAGE']}</p>

                {exceededItemsMessages.map((message, index) => (
                  <li key={index}>{message}</li>
                ))}
            </>
          ) : typeof errorMessage === 'string' ? (
            i18n[errorMessage] ?? errorMessage
          ) : null}
        </Styled.Body>

        <Styled.Footer>
          <Styled.CloseButtonContainer>
            <Button size="lg" onClick={onClose} variant="primary">
              {i18n['Okay']}
            </Button>
          </Styled.CloseButtonContainer>
        </Styled.Footer>
      </Styled.Container>
    </Modal>
  );
};

export default WarningModal;
